// extracted by mini-css-extract-plugin
export default {"root":"style_root__U-w1f","sorted":"style_sorted__1X3TL","sortedDesc":"style_sortedDesc__qPvOy"};